function getAppCtx() {
    return window.APP_CONTEXT;
}
var getAppCtxProxy = function () {
    return new Proxy({}, {
        get: function (_, prop) {
            var getCtxValue = function () {
                var ctx = getAppCtx();
                var value = ctx && prop in ctx ? ctx[prop] : undefined;
                return { ctx: ctx, value: value };
            };
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return new Proxy(function () { }, {
                get: function (_, p) {
                    var value = getCtxValue().value;
                    if (typeof value === 'object' && value !== null) {
                        if (p in value) {
                            return value[p];
                        }
                    }
                    return value;
                },
                apply: function (_, __, args) {
                    var _a = getCtxValue(), ctx = _a.ctx, value = _a.value;
                    if (typeof value === 'function') {
                        return value.apply(ctx, args);
                    }
                    else {
                        return value;
                    }
                },
            });
        },
    });
};
var AppCtx = getAppCtxProxy();
var $gt = AppCtx.gt;
AppCtx.store;
var request = AppCtx.request;
AppCtx.router;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
__BASEURL__ || window.location.origin;
/** @deprecated */
AppCtx.router;
/** @deprecated */
AppCtx.store;

export { $gt, AppCtx, getAppCtx, getAppCtxProxy, request };
